export const SearchTextField = {
    paddingLeft: '8px',
    height: 36,
}